import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';
import { useDeleteShippingMethod } from '../../hooks/use-delete-shipping-method';
import type { ShippingMethodApiResponse } from '../../types/shipping-method';

export function DeleteShippingMethodModal({
  method,
  isOpen,
  closeModal,
}: {
  method: ShippingMethodApiResponse | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const deleteMethod = useDeleteShippingMethod();

  if (!method) {
    return null;
  }

  function handleDelete(method: ShippingMethodApiResponse) {
    deleteMethod.mutate(method.id, {
      onError: (error) => {
        console.error(error);
        notificationHandler.error(
          t('features:shipping_methods.common.notifications.errors.delete_failed', {
            name: method.title,
          }),
        );
      },
      onSuccess: () => {
        notificationHandler.success(
          t('features:shipping_methods.common.notifications.success.delete_succeeded', {
            name: method.title,
          }),
        );
      },
    });
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('buttons:delete'),
        onClick: () => {
          handleDelete(method);
          closeModal();
        },
        danger: true,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>
        {t('features:shipping_methods.components.delete_shipping_method_modal.title')}
      </Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="sm">
          {t('features:shipping_methods.components.delete_shipping_method_modal.body', {
            name: method.title,
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
